import React, { useEffect } from "react";
import { Alert } from "antd";
import { Icon } from "Components";
import "./toast.scss";

interface CampaignLimitToastProps {
    visible: boolean;
    message: string;
    onClose: () => void;
    type?: "success" | "warning";
}

const CampaignLimitToast: React.FC<CampaignLimitToastProps> = ({
    visible,
    message,
    onClose,
    type = "warning",
}) => {

    useEffect(() => {
		if (!message) return;
		const timer = setTimeout(onClose, 3000);
		return () => clearTimeout(timer);
	}, [message]);

    if (!visible) return null;

    return (
        <Alert
            message={message}
            type={type}
            showIcon
            closable
            onClose={onClose}
            icon={<Icon type="campaignInfo" />}
            closeText={<Icon type="close" />}
            className={`custom-toaster ${type}`}
        />
    );
};

export default CampaignLimitToast;